import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {AlertService, AuthService, ProfileService} from '@generic/index';
import { AccountService } from '../../services/account.service';
import { ChangePasswordModel } from '../../models/ChangePasswordModel';
import { Subscription } from '../../../../node_modules/rxjs';
import Swal from 'sweetalert2/dist/sweetalert2.all.min.js';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  model: ChangePasswordModel;
  serverError: string[];
  private auth: AuthService;
  navigationSubscription: Subscription;
  constructor(private router: Router, private api: AccountService, private alert: AlertService, private profile: ProfileService) {
    this.model = new ChangePasswordModel();
    const profileData = this.profile.get();
    this.model.userName = profileData.email;
  }

  ngOnInit() {}
  save() {
    this.api.changePassword(this.model).subscribe(
      data => {
        if (data.status) {
          Swal.fire('', 'Password changed successfully. Please login again', 'success').then((result) => {
            if (result) {
              this.auth.clearLogout();
              this.auth.goToLoginPage();
            }
          });
        } else {
          Swal.fire('', data.message, 'error');
        }
      },
      err => {
        Swal.fire('', 'Server Error - Please try later', 'error');
      }
    );
  }

  goToProfile() {
    this.router.navigate(['account', 'profile']);
  }
}
